import { z } from 'zod';
import { StudyPageLocaleSchema } from './StudyPageContent.js';
export const ExperienceBindingSchema = z
    .object({ profileId: z.string().uuid().nullable() })
    .strict();
export const ResolvedExperienceSchema = z.object({
    profileId: z.string().uuid().nullable(),
    revision: z.number().int().nullable(),
    defaultsVersion: z.number().int(),
    studyContent: StudyPageLocaleSchema.optional(),
    texts: z.record(z.string(), z.string()),
});
//# sourceMappingURL=ParticipantExperience.js.map